import { UPDATE_SPINNER_STATE } from "./types"

export const updateSpinnerState = (data) => {
    return {
        type: UPDATE_SPINNER_STATE,
        data
    }
}